import { Products as Product } from '@/@types';

type ProductProps = {
    info:string,
};

export default function ProductTabInfo({ info }: ProductProps) {
    return (
        <div 
            className="p-8
                [&_h2]:text-3xl [&_h2]:font-bold [&_h2]:mt-6 [&_h2]:mb-3 [&_h2]:text-gray-900
                [&_h3]:text-xl [&_h3]:font-semibold [&_h3]:mt-4 [&_h3]:mb-2 [&_h3]:text-gray-800
                [&_p]:text-lg [&_p]:leading-relaxed [&_p]:mb-4 [&_p]:text-gray-600"
            dangerouslySetInnerHTML={{ __html: info }} 
        />
    )
}
